import React, {Component} from 'react';
import Joi from 'joi-browser';
import Input from './Input';
import Input2 from './Input2';
import TextInput from './TextInput';
import TextArea from './TextArea';
import toastr from 'toastr';
import http from "../../services/httpService";
import {getJwt} from "../../services/authService";

class Form extends Component {

    state = {
        data: {},
        errors: {},
        terms_conditions: false,
        spinnerActive: false,
        passwordShow: false
    };

    validate = () => {
        const {data} = this.state;
        // console.log('data validate():', data)

        const options = {abortEarly: false};
        const {error} = Joi.validate(data, this.schema, options);
        if (!error) return null;

        const errors = {};
        for (let item of error.details) {
            errors[item.path[0]] = item.message;
        }

        return errors;
    };

    validateProperty = ({name, value}) => {
        const obj = {[name]: value};
        const schema = {[name]: this.schema[name]};
        const {error} = Joi.validate(obj, schema);
        return error ? error.details[0].message : null;
    };

    handleFormSubmit = e => {
        // console.log('enters handleFormSubmit');
        e.preventDefault();
        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        }

        const errors = this.validate();


        this.setState({errors: errors || {}});
        //console.log("FeedAutopush errors ", errors);
        if (errors && errors.name) return;
        this.doSubmit();
    };

    responseFacebook = async (response) => {
        //console.log('Ovo je responseFacebook', response)
        if (response.status !== 'unknown' || (typeof (response.status) !== 'undefined')) {
            if (response.name !== "" && (typeof (response.name) !== 'undefined')) {
                if (response.email && response.email !== "") {
                    await http.post('api/login_facebook', response, {headers: {authorization: getJwt()}});
                    var names = response.name.split(' ');
                    let firstName, lastName = "";
                    if (!names || names.length <= 1) {
                        firstName = response.name;
                        lastName = '';
                    } else {
                        firstName = names.slice(0, -1).join(' ');
                        lastName = names.slice(-1).join(' ');
                    }
                    const data = {
                        email: response.email,
                        password: "emFBppp20ito",
                        first_name: firstName,
                        last_name: lastName,
                        profile_photo: response.picture.data.url
                    };
                    this.setState({data});
                    const type = "facebook";
                    this.doSubmit(type);
                } else {
                    toastr.error("Error Code #14003: Email obtain permission has to be checked in order to register!")
                }
            }
        } else {
            toastr.error("Error Code #14004:Facebook response undefined! Please try later, or,  try standard register approach instead.")
        }
    };

    togglePasswordShow = () => {
        this.setState({
            passwordShow: !this.state.passwordShow
        })
    }

    enablePlatform = async (e) => {
        const feed = e.target.title;
        const platform = e.target.id;

        try {
            const resultEnable = await http.get('api/feed/' + feed + '/platform/' + platform, {headers: {authorization: getJwt()}});
            //console.log("enablePlatform fun enablePlatform resultEnable", resultEnable);
            //let platforms_enabled = [];
            if (resultEnable.data.data) {
                //let selected_source_check = resultEnable.data.data;
                //let platforms_enabled = selected_source_check.platforms_enabled;
                //console.log("enablePlatform platforms_enabled enablePlatform platforms_enabled", platforms_enabled);
                //console.log("enablePlatform platforms_enabled enablePlatform this.props", this.props);
                //this.toggleFB();
                //this.setState({
                //    //platforms_enabled: selected_source.platforms_enabled ? selected_source.platforms_enabled : ["fb", "wp"]
                //    platforms_enabled: selected_source_check.platforms_enabled || []
                //});
            }
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Error Code #14005: Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error('Error Code #14006: '+ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    };

    termsWarning = () => {
        toastr.error('Error Code #14007: Please read and check Terms & Policy in order to register.')
    };

    renderButton(label, name = null, id = null, className = "btn btn-action btn-sm m-sm-b center", disabled = null) {
        if (disabled === null) {
            return <button
                type="submit"
                action="submit"
                className={className}
                disabled={this.validate()}>{label}
            </button>
        } else {
            return <button
                type="submit"
                action="submit"
                className={className}
                disabled={disabled}>{label}
            </button>
        }
    };

    renderButtonSpinner(label) {
        return <button
            type="submit"
            action="submit"
            className='btn-action btn-sm m-sm-b center'
            disabled={true}>{label} <i className='fa fa-spin fa-spinner'></i>
        </button>

    };

    renderRegisterButton(label) {
        return <button
            type="submit"
            action="submit"
            className={this.validate() ? "btn btn-action disabled" : "btn btn-action"}
            disabled={this.validate()}>
            {label}
        </button>

    };

    renderRegisterButtonSpinner(label, className) {
        return <button
            type="submit"
            action="submit"
            className={className}
            disabled={true}>{label} <i className='fa fa-spin fa-spinner'></i>
        </button>

    };

    renderButtonType(label, func) {
        return <button
            type="button"
            onClick={func}
            className='btn-primary block full-width m-b'
        >{label}
        </button>
    };

    renderInput(name, type = "text", placeholder, disabled = false, autoFocus = false, maxLength = 'auto', id = '', className = '', onChange, onKeyDown) {
        const {data, errors} = this.state;
        let error = null;
        if (errors && errors[name]) {
            error = errors[name].replace(/["']/g, "");
        }
        return <Input
            tabIndex="0"
            name={name}
            value={data[name] || ""}
            type={this.state.passwordShow ? 'text' : type}
            // label={label}
            disabled={disabled}
            onChange={this.handleChange}
            error={error}
            placeholder={placeholder}
            togglePasswordShow={this.togglePasswordShow}
            passwordShow={this.state.passwordShow}
            autoFocus={autoFocus}
            maxLength={maxLength}
            // onFocus={() => updateFocus(name)}
            // onBlur={()=>updateFocus('')}
            id={id}
            className={className}
            onKeyDown={onKeyDown}

        />
    };

    // renderInput name for password must contain word password in it for passwordShow to work

    renderInput2(name, label, type = "text", disabled = false) {
        const {data, errors} = this.state;
        return <Input2
            name={name}
            value={data[name] || ""}
            type={type}
            label={label}
            disabled={disabled}
            onChange={this.handleChange}
            error={errors[name]}/>
    };

    renderInputControlled(name, label, type = "text", value = "") {
        const {data, errors} = this.state;
        let valueSet = data[name] ? data[name] : value;
        return <Input
            name={name}
            value={valueSet}
            type={type}
            label={label}
            onChange={this.handleChange}
            error={errors[name]}/>

    };

    renderTextInput(name, placeholder) {
        const {data, errors} = this.state;
        return <TextInput
            name={name}
            placeholder={placeholder}
            value={data[name] || ""}
            onChange={this.handleChange}
            error={errors[name]}/>
    };

    renderTextArea(name, type = "text", placeholder, disabled = false, autoFocus = false, rows = null) {
        const {data, errors} = this.state;
        return <TextArea
            name={name}
            value={data[name] || ""}
            type={this.state.passwordShow ? 'text' : type}
            // label={label}
            disabled={disabled}
            onChange={this.handleChange}
            error={errors[name]}
            placeholder={placeholder}
            togglePasswordShow={this.togglePasswordShow}
            passwordShow={this.state.passwordShow}
            autoFocus={autoFocus}
            rows={rows}
        />
    };

    renderCheckbox(name) {
        const {errors, terms_conditions} = this.state;

        return <label className="terms m-m-b checkbox">
            I accept <a target="_blank" style={{margin: 0}} rel="noopener noreferrer"
                        href="/privacy">Terms &amp; Conditions</a>
            <input
                type="checkbox"
                name={name}
                value={terms_conditions}
                onChange={this.handleCheckChange}
                error={errors[name]}/>
            <span className="checkmark"></span>
        </label>
    };

    handleCheckChange = ({currentTarget: input}) => {
        const {terms_conditions} = this.state;
        this.setState({terms_conditions: !terms_conditions});
    };

    skipStep = () => {
        this.setState({redirecting: true});
    };

    backStep = async (feed_id = null) => {
        //console.log("backStep feed_id ", feed_id);
        //console.log("backStep this.props ", this.props);
        if (feed_id && !feed_id.target) {
            //const feed_method = e.target.name || "";
            //const activate = feed_method === "activate";

            if (feed_id !== 22 && feed_id != 24) {
                try {
                    //const result_delete = await http.delete('api/feed/' + feed_id, {headers: {authorization: getJwt()}});
                    await http.delete('api/feed/' + feed_id, {headers: {authorization: getJwt()}});
                    toastr.info("Previously added workspace deleted!");
                    //
                    //if(this.state.user.sources.data && this.state.user.sources.data.length > 0)
                    //{
                    //    let deleted_source_check = this.state.user.sources.data.filter(el => {return (el.id.toString() !== feed_id.toString())});
                    //    //console.log("Main deleteFeed result_delete deleted_source", deleted_source_check);
                    //    if(deleted_source_check.length)
                    //    {
                    //        this.setState({
                    //            user: Object.assign(
                    //                {},
                    //                this.state.user,
                    //                {
                    //                    sources:
                    //                    {
                    //                        data: [...deleted_source_check]
                    //                    }
                    //                }
                    //            )
                    //        });
                    //        this.setState({
                    //            selected_source:deleted_source_check[0].id
                    //        });
                    //    }
                    //    //platforms_enabled = selected_source_check[0].platforms_enabled;
                    //}

                } catch (ex) {
                    toastr.error('Error Code #14008: '+ex.response.data.message);
                }
            }
        }
        this.setState({back: true});
    };

    handleChange = ({currentTarget: input}) => {
        const errors_obj = this.state.errors;
        const errors = {...errors_obj};
        const errorMessage = this.validateProperty(input);
        if (errorMessage) {
            errors[input.name] = errorMessage;
        } else {
            delete errors[input.name];
        }

        const data_obj = this.state.data;
        const data = {...data_obj};
        data[input.name] = input.value;
        this.setState({data, errors});
        //this.props.signinUser({email, password});
    };
}

export default Form;